var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{attrs:{"id":"tc7"}},[_c('div',[_vm._t("product"),_vm._t("bt_purchase"),_vm._t("download"),_vm._t("table")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }